import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)
//
let actions = {
  getByCode: { // 通过Code 查询企业
    'method': 'GET',
    'url': '/api/v1/companies/by_code{/code}'
  },
  open: { // 开启邀请
    'method': 'PUT',
    'url': '/api/v1/companies/open'
  },
  close: { // 关闭邀请
    'method': 'PUT',
    'url': '/api/v1/companies/close'
  },
  hr: { // 获取HR列表
    'method': 'GET',
    'url': '/api/v1/companies/hrs/'
  },
  join: { // 加入企业
    'method': 'PUT',
    'url': '/api/v1/companies/hrs/join'
  },
  leave: { // HR 离职
    'method': 'PUT',
    'url': '/api/v1/companies/hrs{/hr}/leave'
  },
  setManager: { // 加入企业
    'method': 'PUT',
    'url': '/api/v1/companies/hrs{/hr}/set_manager'
  },
  cancelManager: { // HR 离职
    'method': 'PUT',
    'url': '/api/v1/companies/hrs{/hr}/cancel_manager'
  },
  updateRange: { // HR 离职
    'method': 'PUT',
    'url': '/api/v1/companies/hrs{/hr}/update_range'
  }
}

export default Vue.resource('/api/v1/companies{/_id}', {}, actions)



// WEBPACK FOOTER //
// ./src/resource/company.js